import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const greaterCarrollwoodConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Greater Carrollwood Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Greater Carrollwood, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_greater_carrollwood',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Greater Carrollwood',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Greater Carrollwood Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide expert tree care across 
     the established communities of <strong>Greater Carrollwood</strong>. This 
     expansive Northwest Tampa area encompasses a wide range of residential 
     neighborhoods from golf course communities to lakefront subdivisions
     all with mature trees that have grown large enough to require consistent 
     professional management. Our team handles the hazards that come with 
     decades of Florida tree growth.`,

    `We specialize in <strong>hazardous tree removal and canopy management across 
     diverse residential settings</strong> large overhanging limbs near homes 
     and community amenities, storm damaged trees, lakefront tree work with 
     root instability, and canopy thinning that significantly reduces your 
     property's wind load exposure before hurricane season.`,

    `<strong>Sam's Tree Service</strong> delivers trusted, affordable tree care 
     throughout <strong>Greater Carrollwood</strong> and the surrounding 
     <strong>Northwest Hillsborough</strong> communities keeping every 
     property safe and well maintained all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Greater Carrollwood, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_GreaterCarrollwood = () => <LocationPage config={greaterCarrollwoodConfig} />;
export default Services_GreaterCarrollwood;
